import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './index.css';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  width: PropTypes.string,
  colSpan: PropTypes.string,
  rowSpan: PropTypes.string,
  alignCenter: PropTypes.bool,
  noPadding: PropTypes.bool,
  noTopBottomPadding: PropTypes.bool,
  noBorder: PropTypes.bool,
  noBorderRight: PropTypes.bool,
  borderRight: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
};

const defaultProps = {
  width: 'auto',
  alignCenter: false,
  noPadding: false,
  colSpan: undefined,
  rowSpan: undefined,
  noTopBottomPadding: false,
  noBorder: false,
  noBorderRight: false,
  borderRight: false,
  className: '',
  id: '',
};

const Cell = props => {
  const {
    children,
    width,
    alignCenter,
    colSpan,
    rowSpan,
    borderRight,
    noPadding,
    noTopBottomPadding,
    noBorder,
    noBorderRight,
    className,
    id,
  } = props;
  const cellClass = classNames('Table__cell', className, {
    'Table__cell--centered': alignCenter,
    'Table__cell--no_padding': noPadding,
    'Table__cell--no_top_bottom_padding': noTopBottomPadding,
    'Table__cell--no_border': noBorder,
    'Table__cell--no_border_right': noBorderRight,
    'Table__cell--border_right': borderRight,
  });

  return (
    <td
      id={id}
      className={cellClass}
      width={width}
      colSpan={colSpan}
      rowSpan={rowSpan}
      cellSpacing="0"
      cellPadding="0"
    >
      {children}
    </td>
  );
};

Cell.propTypes = propTypes;
Cell.defaultProps = defaultProps;

export default Cell;



// WEBPACK FOOTER //
// ../ui-components/components/Table/Cell.jsx